
const pendingPaymentsQuery = `
  with location_base as (
    select 
      uuid as location_id
    from avocado.data_location
    where uuid = $1 
  ),
  location_transactions as (
    select
      vt.transaction_uuid as id,
      vt.location_id,
      vt.txn_id,
      vt.company_code,
      vt.payment_plan_id,
      vt.txn_type,
      vt.doc_number as quickbooks_doc_number,
      vt.code,
      vt.description,
      vt.due_date,
      vt.amount,
      vt.paid_amount
    from location_base lb
    cross join avocado.get_quickbookstransactions_by_location(lb.location_id) vt
  ),
  pending AS (
    SELECT
      p.id,
      p.location_id,
      due_date,
      -- The amount from paystack is in the currencies subunit, convert to main unit
      case when p.total_amount > 0 then p.total_amount
      else p.amount_in_cents / 100  end as amount,
      'pending invoice payment' AS txn_type,
      quickbooks_doc_number
    FROM location_base lb
    inner join avocado.data_payment p on p.location_id = lb.location_id 
    LEFT JOIN location_transactions t
      ON t.txn_type = 'payment'
     AND t.description = "p"."payment_data" ->> 'reference'
     AND t.location_id = p.location_id
    WHERE (p.status = 'success' OR p.status = 'client_side_paid')
    and p.payment_method != 'credit' -- we need exclude credits from pending payments list
    and t.id IS NULL
    -- Payments made prior to the specified date should not be included in the pending payment logic.
    and p.created_at > '2023-06-08'

    UNION

    SELECT
      p.id,
      p.location_id,
      due_date,
      -- The amount from paystack is in the currencies subunit, convert to main unit
      p.amount_in_cents / 100 as amount,
      case 
        when p.qbo_txn_id is not null and p.qbo_company_code is not null then 'pending invoice payment'
        else 'pending installment payment'
      end as txn_type,
      quickbooks_doc_number
    FROM location_base lb 
    inner join avocado.data_paygcreditpayment p on p.location_id = lb.location_id
    left join location_transactions t on
      t.txn_type = 'payment' and
      t.description = p.payment_data ->> 'reference'
    WHERE t.id is null
  )
`

const pendingPaymentBalanceQuery = `
  ${pendingPaymentsQuery}
  SELECT
    lb.location_id,
    coalesce(sum(amount), 0) as amount
  from location_base lb
  left join pending p on p.location_id = lb.location_id
  group by 1
`

module.exports = {
  pendingPaymentBalanceQuery
}
